/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creation_Detail_Meta_TitleInputs */

const en_creation_detail_meta_title = /** @type {(inputs: Creation_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation Detail`)
};

const es_creation_detail_meta_title = /** @type {(inputs: Creation_Detail_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalle de creacion`)
};

/**
* | output |
* | --- |
* | "Creation Detail" |
*
* @param {Creation_Detail_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const creation_detail_meta_title = /** @type {((inputs?: Creation_Detail_Meta_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creation_Detail_Meta_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creation_detail_meta_title(inputs)
	return es_creation_detail_meta_title(inputs)
});